/**
 * Sidbyten startar Autofrance-laddaren (ägaren 2026-10-08: "kan vi ha loading-märket när folk är inne på vår sida
 * och söker?"). Next anropar onRouterTransitionStart när en navigering BÖRJAR — router.push från sökrutan, Link-klick,
 * filter i adressen — så ingen sökruta behöver ändras. Bakåt/framåt (traverse) brukar komma ur cachen och visas inte.
 */
export function onRouterTransitionStart(_url: string, navigationType: 'push' | 'replace' | 'traverse') {
  if (navigationType === 'traverse') return;
  try { window.dispatchEvent(new CustomEvent('af-laddar', { detail: 'start' })); } catch { /* gammal webbläsare */ }
}
